let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("kVX56"), load("76n7a"), load("l253H"), load("3EDTs")]).then(() => parcelRequire('6qBzG'));